import type { MakeRequest } from "./types/MakeRequest";
import type { Options } from "./types/Options";

export const makePatch =
  ({ makeRequest }: { makeRequest: MakeRequest }) =>
  (url: string, options: Options = {}) => {
    options.method = "patch";

    return makeRequest(url, options);
  };
